module.exports = __webpack_public_path__ + "static/media/kollegen.6d0e1642.png";